
<template>
  <div>
    <!-- PRE VISUALIZAÇÃO DO ARQUIVO -->
    <v-btn small block color="red darken-1" dark v-if="file_kind == 'pdf'" :href="`${local_file_preview ? local_file_preview.url : attached_file_url}`" target="_blank" >
      <v-icon left small>mdi-eye</v-icon>
      <span>{{attachment_text.look}}</span>
    </v-btn>
    <div v-if="file_kind == 'img'" >
      <v-btn small block color="red darken-1" dark v-if="local_file_preview ? local_file_preview.url : attached_file_url" @click="dialog = !dialog" >
        <v-icon left small>mdi-eye</v-icon>
        <span>{{attachment_text.look}}</span>
      </v-btn>
    </div>
    <!-- INPUT DO ANEXO -->
    <div :class="['d-flex', (attached_file_url || local_file_preview ? 'mb-n5 pt-3' : '')]   " v-if="change_file">
      <FileInput v-on="$listeners" @done="change_file = false" :attribute_name="attribute_name"
      :update_infos="update_infos" @filePreview="handleFilePreview" :is_creating="is_creating"
      ref="file_input"></FileInput>
    </div>
    
    <!-- BOTÕES DE EDIÇÃO -->
    <div class="d-flex justify-end py-3" v-if="!readonly">
      <v-btn small class="mr-2" elevation="2" :color="!change_file ? 'primary' : 'error'" @click="cancelEdit" > 
        <v-icon small left>{{ !change_file ? 'mdi-pencil' : 'mdi-close' }} </v-icon>
        {{ !change_file ? (!is_creating ? attachment_text.change : attachment_text.add) : 'Cancelar' }}
      </v-btn>
      <v-btn small v-if="change_file && !is_creating" class="" elevation="2" color="success" @click="updateFile" :disabled="!file_exists"> 
        <v-icon small left>mdi-content-save</v-icon>
        Salvar anexo
      </v-btn>
    </div>

    <!-- DIALOG PARA PRE VISUALIZAÇÃO DO ANEXO -->
    <DialogSeeAttachment :attached_file_url="attached_file_url"
      :local_file_preview="local_file_preview" :dialog="dialog"
    ></DialogSeeAttachment>
    
  </div>
</template>

<script>

export default {
  name: 'FileAttachment',
  components:{
    DialogSeeAttachment: () => import("@/components/shared/DialogSeeAttachment.vue"),
    FileInput: () => import("@/components/shared/FileInput.vue"),
  },
  props: {
    update_infos: {
      type: Object,
      default: {
        MODEL: '',
        id: ''
      }
    },
    // URL PARA VISUALIZAR ARQUIVO
    attached_file_url: {
      type: String,
      default: null
    },
    is_creating: {
      type: Boolean,
      default: false
    },
    attribute_name:{
      type: String,
      default: "attached_file"
    },
    attachment_text:{
      type: Object,
      default: () => {return {add:"Adicionar anexo", change: "Alterar anexo", look:"Visualizar Anexo"} }
    },
    readonly:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      dialog: false,
      change_file: false,
      file_exists: false,
      local_file_preview: null,
      fullscreen: false,
    }
  },
  methods: {
    handleFilePreview(local_file_preview){
      this.local_file_preview = local_file_preview
      if(local_file_preview){
        this.file_exists = true
      }else{
        this.file_exists = false
      }
    },
    cancelEdit(){
      this.change_file = !this.change_file
      this.local_file_preview = null
      if(this.is_creating){
        this.$refs.file_input?.deleteFile()
      }
    },
    updateFile(id){
      if (!this.$refs.file_input) return Promise.resolve()
      return this.$refs.file_input.updateFile(id)
    },
  },
  computed: {
    file_kind(){
      if(this.local_file_preview || this.attached_file_url){
        let file_url = this.local_file_preview ? this.local_file_preview.name : this.attached_file_url
        const path = String(file_url || '').split('?')[0].split('#')[0]
        if (path.toLowerCase().endsWith('pdf')) {
          return 'pdf'
        }else{
          return 'img'
        }
        
      }else{
        return 'img'
      }
    },
  },
}
</script>
